import { gql } from '@apollo/client';

export const ADD_GROUP_ATTENDEES_TO_ACTIVITY = gql`
  mutation addGroupAttendeesToActivity($input: AddGroupAttendeesToActivityInput!) {
    activity: addGroupAttendeesToActivity(input: $input) {
      id
    }
  }
`;
